var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';

import ReactPlayer from 'react-player';

import MarkdownMedia from "../../Markdown/components/MarkdownMedia";
import { isSerializedFile, prepareHTMLMediaView } from "../../../shared/fileUploadUtils";

export const RenderAttachment = ({ attachment }) => {
  const { mimetype = '' } = attachment;

  const fileURL = isSerializedFile(attachment) ? prepareHTMLMediaView(attachment) : attachment.url;

  if (mimetype.includes('image')) {
    return fileURL ? /*#__PURE__*/
    _jsx("img", { src: fileURL, alt: attachment.originalname }) : /*#__PURE__*/

    _jsx("img", { src: `/api/files/${attachment.filename}`, alt: attachment.originalname });

  }

  const isVideoAudio = mimetype.includes('video') || mimetype.includes('audio');

  const isFromSupportedSite = attachment.url && ReactPlayer.canPlay(attachment.url);

  if (isVideoAudio || isFromSupportedSite) {
    return fileURL ? /*#__PURE__*/
    _jsx(MarkdownMedia, { config: `(${fileURL})` }) : /*#__PURE__*/

    _jsx(MarkdownMedia, { config: `(/api/files/${attachment.filename})` });

  }

  return null;
};